<app-banner [page]="'home'"></app-banner>

<div class="row">
    <div class="col-md-12">
        <app-page-details [page]="'hiring-partner'"></app-page-details>  
    </div>
</div>  